export const DATADOG_INTAKE_SETUP_COPY = {
  pageTitle: "How should Datadog errors become tasks?",
  wizardStepConnect: "Connect Datadog",
  wizardStepConnectHelper:
    "Enter the API key and an application key. The API key has no scopes. A restricted application key needs only create_webhooks, manage_integrations, and error_tracking_read.",
  wizardStepConnectExisting: "Choose the Datadog account that SuperPlane will monitor.",
  wizardStepService: "Which Datadog service should create tasks?",
  wizardStepServiceHelper:
    "Set the Error Tracking monitor query to that service. Keep @webhook-superplane in the monitor message.",
  importExistingHelper: "SuperPlane adds the 10 newest open errors from this service.",
  importExistingHelperOff: "SuperPlane does not import existing errors.",
  wizardConnect: "Connect Datadog",
  wizardContinue: "Continue",
  wizardFinish: "Finish",
  wizardFinishing: "Finishing...",
  wizardConnectionsLoading: "Loading Datadog connections...",
  wizardServicesLoading: "Loading Datadog services...",
  wizardServicesError: "SuperPlane could not load Datadog services.",
  wizardServicesEmpty: "No recent Error Tracking services. Enter a service name.",
  wizardNoMatchingServices: "No matching services.",
  wizardServiceNameLabel: "Service name",
  wizardServiceNamePlaceholder: "checkout",
  wizardRetry: "Try again",
  wizardCreateError: "SuperPlane could not create the Datadog intake.",
} as const;
